import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './dropdown-select.css';

export default class DropdownSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange(e) {
    const selectedIndex = this.props.options.findIndex(
      (option) => String(option.value) === e.target.value,
    );
    this.props.onChange(this.props.options[selectedIndex], selectedIndex, e);
  }

  onFocus(e) {
    this.setState({ inFocus: true });
    if (this.props.onFocus) this.props.onFocus(e);
  }

  onBlur(e) {
    this.setState({ inFocus: false });
    if (this.props.onBlur) this.props.onBlur(e);
  }

  getClassName() {
    const classes = ['stylized-select'];
    if (this.props.className) classes.push(this.props.className);
    if (this.props.disabled) classes.push('disabled');
    if (this.state.inFocus) classes.push('focused');
    return classes.join(' ');
  }

  getLabel() {
    const { disabled, title } = this.props;
    if (title) {
      return (
        // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
        <label className={`stylized-select-title ${disabled ? 'disabled' : ''}`}>{title}</label>
      );
    }
    return null;
  }

  render() {
    const selected = this.props.options[this.props.selectedIndex] || {};
    const { options, disabled, ...other } = this.props;
    delete other.onChange;
    delete other.onFocus;
    delete other.onBlur;
    delete other.value;
    delete other.className;
    delete other.selectedIndex;

    return (
      <div className="stylized-select-container">
        {this.getLabel()}
        <div className={this.getClassName()}>
          <span className="stylized-select-value">{selected.label}</span>
          <i className="stylized-select-caret fa fa-chevron-down pull-right" />
          <select
            className="stylized-select-select"
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            value={selected.value}
            disabled={disabled}
            {...other}
          >
            {options.map((option, i) => (
              <option key={i} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

DropdownSelect.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  selectedIndex: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

DropdownSelect.defaultProps = {
  title: '',
  options: [],
  selectedIndex: 0,
};
